import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import Image from 'next/image';
interface Props {
  link: string;
  label: string;
}
export default function RedditLink(t0) {
  const $ = _c(8);
  const {
    link,
    label
  } = t0;
  let t1;
  if ($[0] !== link) {
    t1 = new URL(link);
    $[0] = link;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="relative w-10 h-10"><Image src="/reddit-logo.svg" alt="Telegram Social Link" priority={true} fill={true} /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== label) {
    t3 = <p className="mt-1 text-center">{label}</p>;
    $[3] = label;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t3) {
    t4 = <Link href={t1} className="relative flex flex-col items-center justify-center">{t2}{t3}</Link>;
    $[5] = t1;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}